export default function($) {

	var $scrollToBottom = $('.scroll-to-bottom');

	var displayScrollButton = function() {
		if ( $(window).width() > 960 ) {
			if ($(window).scrollTop() > 50) {
				$scrollToBottom.hide();
			} else {
				$scrollToBottom.fadeIn();
			}
		} else {
			$scrollToBottom.hide();
		}
	}

	displayScrollButton();

	$(window).on('scroll', function() {
		displayScrollButton();
	});

	$(window).on('resize', function() {
		displayScrollButton();
	})

	$scrollToBottom.on('click', function(e) {
	  $("html, body").animate({scrollTop: $($(this).attr('href')).offset().top + 150}, 800);
	});

}
